import { useQuery } from '@tanstack/react-query';
import apiClient from 'services/apiClient';

export const TOTAL_EARNINGS_KEY = ['total-earnings'];

const useTotalEarnings = () =>
    useQuery(
        TOTAL_EARNINGS_KEY,
        () => apiClient.get('/Statistics/Earnings/Total').then(r => r.data),
        { staleTime: 5 * 60 * 1000 }
    );

export default useTotalEarnings;
